import { FunctionComponent } from 'react'
import styles from './timeBarSlots.module.scss'
import Desktop from '@/modules/desktopMobile/desktop'
import { TimBarSlots } from './defineSlots'
import { HourglassBottom } from '@mui/icons-material'
import { CalendarEventType } from '@/types/Calendar'

interface TimBarSlotsProps {
    timBarSlots: TimBarSlots[]
    totalMinutes: number
    handleSelect: (slot: TimBarSlots) => void
    interactiveEmptySlots?: boolean
}

const TimeBarSlots: FunctionComponent<TimBarSlotsProps> = ({
    timBarSlots,
    totalMinutes,
    handleSelect,
    interactiveEmptySlots = false
}: TimBarSlotsProps) => {
    return (
        <div className={styles.TimeBarSlots} style={{ height: 50 + 'px' }}>
            {timBarSlots.map((slot: TimBarSlots, index: number) => {
                const startMinutes: number = slot.start
                    .split(':')
                    .reduce((acc: number, time: string) => 60 * acc + parseInt(time, 10), 0)

                const endMinutes: number = slot.end
                    .split(':')
                    .reduce((acc: number, time: string) => 60 * acc + parseInt(time, 10), 0)

                const width: number = ((endMinutes - startMinutes) / totalMinutes) * 100

                const connectedToPrevious: boolean = slot.id !== undefined && timBarSlots[index - 1]?.id === slot.id
                const connectedToNext: boolean = slot.id !== undefined && timBarSlots[index + 1]?.id === slot.id

                return (
                    <div
                        key={index}
                        className={`${styles.TimeSlot} ${slot.backgroundStyle} ${
                            !slot.id && interactiveEmptySlots ? styles.Clickable : ''
                        }`}
                        onClick={() => handleSelect(slot)}
                        style={{
                            width: `${width}%`,
                            borderTopLeftRadius: connectedToPrevious ? 0 : 10,
                            borderBottomLeftRadius: connectedToPrevious ? 0 : 10,
                            borderTopRightRadius: connectedToNext ? 0 : 10,
                            borderBottomRightRadius: connectedToNext ? 0 : 10
                        }}
                    >
                        {slot.id && slot.isPreparation && (
                            <Desktop>
                                <p
                                    className={`${styles.PreparationLabel} ${connectedToNext ? styles.Before : styles.After}`}
                                >
                                    {connectedToNext ? slot.start : slot.end}
                                </p>
                            </Desktop>
                        )}
                        {slot.id && !slot.isPreparation && (
                            <Desktop>
                                <div className={styles.StartEnd}>
                                    <p className={styles.Text}>{slot.start}</p>
                                    {slot.type === CalendarEventType.REGULAR_REQUEST && (
                                        <HourglassBottom className={styles.Icon} />
                                    )}
                                    <p className={styles.Text}>{slot.end}</p>
                                </div>
                            </Desktop>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default TimeBarSlots
